import React from "react";
import ReactDOM from "react-dom";
import "./styles/reset.css";
import "./styles/colors.css";
import "./styles/index.css";
import "./styles/results.css";
import "./styles/searchbar.css";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
